import tokenizer from './tokenizer'
import compiler from './compiler'

export default context => {
  const { grants = {} } = context
  const roles = Object.keys(grants)

  const tokens = roles.reduce(
    (acc, role) => ({
      ...acc,
      [role]: grants[role].map(grant => tokenizer(grant)).flat(),
    }),
    {},
  )

  return role => {
    const roleTokens = tokens[role] || []
    return compiler(roleTokens, [], context)
  }
}
